import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { queryClient } from '~/lib/api/queryClient';

export const Provider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
